import {ChangeDetectorRef, Component, EventEmitter, inject, Input, Output} from '@angular/core';
import {NgClass, NgIf, Location} from "@angular/common";
import {MatIcon} from "@angular/material/icon";
import {SideNavService} from "../../nav-bar/Services/side-nav.service";
import {LoginService} from "../../../services/login.service";
import {SharedService} from "../../../services/shared.service";
import {Response} from "../../../models/Response";
import {ActualURLPaths, FeaturesPaths, RootRoutePaths} from "../../../models/routes-constants";
import {Router, RouterLinkActive} from "@angular/router";
import {getMessaging, getToken} from "firebase/messaging";
import {environment} from "../../../../environments/environment";
import {FirebaseInsertToken} from "../../dashboard/Models/firebase.model";
import * as moment from "moment/moment";
import {DashboardService} from "../../dashboard/Services/dashboard.service";
import {
    Bell, Briefcase,
    BriefcaseBusiness,
    Building2,
    CircleUser,
    Github,
    LucideAngularModule,
    Settings2,
    Users,
    Zap
} from "lucide-angular";
import { SharedModule } from "../../../modules/shared/shared.module";
import {SETTINGS_SIDENAV} from "./settings-side-nav-panel.config";
import {HandleErrorService} from "../../../services/handle-error-service";
import {ToastrService} from "ngx-toastr";

@Component({
  selector: 'app-settings-side-nav-panel',
    imports: [
        MatIcon,
        NgIf,
        LucideAngularModule,
        RouterLinkActive,
        NgClass,
        SharedModule
    ],
  templateUrl: './settings-side-nav-panel.component.html',
  styleUrl: './settings-side-nav-panel.component.scss'
})
export class SettingsSideNavPanelComponent {
    sideNavConfig = SETTINGS_SIDENAV;

    @Input() iconsOnlySideNavbarHover!: boolean;
    @Output() toggleSidenav = new EventEmitter<void>();
    iconsOnlySideNavbar: boolean = false;
    isUserLoggedIn: boolean = false;
    isPersonalAccountPresent: boolean = false;
    loggedInUserDetails: Response;
    loggedInUserName: string | null;

    sideNavService = inject(SideNavService)
    loginService = inject(LoginService)
    sharedService = inject(SharedService)
    cdr = inject(ChangeDetectorRef);
    router = inject(Router)
    dashboardService = inject(DashboardService);
    handleErrorService = inject(HandleErrorService);
    location = inject(Location);
    toastrService = inject(ToastrService);


    ngOnInit(): void {
        this.sideNavService.sidenavOpen$.subscribe((open) => {
            this.iconsOnlySideNavbar = !open;
        });

        this.loginService.isUserLoggedIn$.subscribe(() => {
            this.isUserLoggedIn = this.loginService.isLoggedIn();
            this.isPersonalAccountPresent = this.sharedService.isUserRegisteredInPersonalOrganization();
            this.cdr.detectChanges();
        });

        if (this.sharedService.isUserTokenExpired()) {
            this.router.navigate([RootRoutePaths.HOME]);
        } else {
            this.loggedInUserDetails = new Response();
            this.getLoggedInUserName();
            this.validateFCMToken();
        }
    }

    whatIsRoute(route: string) {
        if (route === ActualURLPaths.MANAGE_ORG_MEMBERS) {
            if (!this.sharedService.isUserHasAdminAccessInAnyOrg()) {
                this.toastrService.warning(
                    'You do not have permission to manage organizations.',
                    'Access Denied',
                    { timeOut: 3000 }
                );
                return;
            }
        }

        if (route === ActualURLPaths.PROJECTS) {
            if (!this.sharedService.isUserHasAdminAccessInAnyProject()) {
                this.toastrService.warning(
                    'You do not have permission to manage projects.',
                    'Access Denied',
                    { timeOut: 3000 }
                );
                return;
            }
        }

        this.router.navigate([route]).then().catch(console.error.bind(console));
    }

    checkIsRouteActive(route: string): boolean {
        return this.router.url.includes(route);
    }

    /** This Method will be called to check isFCMTokenValidated and Push Notification Permission Granted or not.*/

    validateFCMToken() {
        if (!this.sharedService.isFCMTokenValidated && "serviceWorker" in navigator && window.isSecureContext) {
            this.requestPermission();
        } else {
            console.log("FCM Token is already validated");
        }
    }

    requestPermission() {
        const messaging = getMessaging();
        getToken(messaging, {vapidKey: environment.firebase.vapidKey})
            .then((currentToken) => {
                if (currentToken) {
                    /** Detect the token is Exist or not for current device */
                    this.dashboardService.detectFirebaseToken("web", this.sharedService.getDeviceId()!).subscribe(
                        (response: any) => {
                            let detectedToken: string = response.data;
                            if (detectedToken == currentToken) {
                                this.sharedService.isFCMTokenValidated = true;
                            } else {
                                let fcmInsertTokenRequestBody = new FirebaseInsertToken();
                                fcmInsertTokenRequestBody.deviceId = this.sharedService.getDeviceId()!;
                                fcmInsertTokenRequestBody.token = currentToken;
                                fcmInsertTokenRequestBody.timestamp =
                                    moment(new Date()).format("YYYY-MM-DD") +
                                    "T" +
                                    moment(new Date()).format("HH:mm:ss");
                                this.dashboardService.insertFirebaseToken(fcmInsertTokenRequestBody).subscribe(
                                    () => {
                                        this.sharedService.isFCMTokenValidated = true;
                                    },
                                    () => {
                                        this.sharedService.isFCMTokenValidated = false;
                                    },
                                );
                            }
                        },
                        () => {
                            /** If token is not exist then insert the token in Backend */
                            let fcmInsertTokenRequestBody = new FirebaseInsertToken();
                            fcmInsertTokenRequestBody.deviceId = this.sharedService.getDeviceId()!;
                            fcmInsertTokenRequestBody.token = currentToken;
                            fcmInsertTokenRequestBody.timestamp =
                                moment(new Date()).format("YYYY-MM-DD") + "T" + moment(new Date()).format("HH:mm:ss");
                            this.dashboardService.insertFirebaseToken(fcmInsertTokenRequestBody).subscribe(
                                () => {
                                    this.sharedService.isFCMTokenValidated = true;
                                },
                                () => {
                                    this.sharedService.isFCMTokenValidated = false;
                                },
                            );
                        },
                    );
                }
            })
            .catch((err) => {
                // this.handleErrorService.handleError(err);
            });
    }


    getLoggedInUserName() {
        this.loggedInUserName = this.sharedService.getLoggedInUserName();
    }

    goBack() {
        if (window.history.length > 1) {
            this.location.back();
        } else {
            this.router.navigate([RootRoutePaths.DASHBOARD]).then().catch(console.error.bind(console));
        }
    }

    protected readonly FeaturesPaths = FeaturesPaths;
    protected readonly CircleUser = CircleUser;
    protected readonly Bell = Bell;
    protected readonly Users = Users;
    protected readonly BriefcaseBusiness = BriefcaseBusiness;
    protected readonly Zap = Zap;
    protected readonly Github = Github;
    protected readonly Settings2 = Settings2;
    protected readonly Building2 = Building2;
    protected readonly Briefcase = Briefcase;
}
